/*
 * Project: LegalPlace assistant
 * File: src/app/indexes/fatherhood.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/

class LpGrandpa {
  buildGrandpa(tree) {
    this.grandpa = tree;
  }

  getFather(id) {
    return this.grandpa[id];
  }
}

export default LpGrandpa;



// WEBPACK FOOTER //
// ./src/app/indexes/fatherhood.js